// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1A3bP","overflowing":"ReadFullNote_overflowing__3jXwF"};